var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _defs, _path, _use, _path2, _use2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsaVirginiaBankAMillion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1820 1820",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0083c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#0095d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#00a6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00aee6"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.501,
    y1: 1.001,
    x2: 0.501,
    y2: -0.001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0083c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#0095d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#00a6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00aee6"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -7.964,
    y1: 1.001,
    x2: -7.964,
    y2: -0.001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0083c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#0095d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#00a6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00aee6"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.5,
    y1: 1.001,
    x2: 0.5,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0083c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#0095d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#00a6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00aee6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M266 292.5c-10 0-18.8 3.7-25.9 11.1-7.4 7.4-10.7 16.3-10.7 26.6 0 10 3.7 18.8 10.7 26.2 7.4 7.4 15.9 11.1 25.9 11.1 10.3 0 19.2-3.7 26.2-11.1 7.4-7.4 10.7-16.3 10.7-26.2 0-10.3-3.7-19.2-10.7-26.6s-15.8-11.1-26.2-11.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M773.489 915.571c-14.403-9.693-31.433-14.765-50.184-14.765-20.11 0-38.861 5.707-56.253 16.758-13.678 9.058-25.726 21.106-35.781 36.506-4.348-9.693-9.058-17.755-14.403-24.096a80.8 80.8 0 0 0-29.44-21.106c-11.685-5.345-24.458-8.062-37.865-8.062-19.385 0-38.136 5.345-55.529 16.034-8.334 5.345-16.758 12.682-25.092 22.103V907.51h-46.198v270.486h46.198V1062.5c0-31.161 2.989-54.26 9.058-68.935 5.707-14.403 14.765-25.817 26.813-34.151s25.092-12.682 38.499-12.682c11.685 0 21.74 2.989 30.165 8.696 8.334 6.069 14.041 13.678 17.392 23.462 3.714 10.417 5.345 30.799 5.345 60.873v138.232h46.198v-107.434c0-35.781 2.989-61.598 8.696-76.635 5.707-14.403 14.403-26.088 26.451-34.785s25.092-13.044 39.495-13.044c11.685 0 21.74 2.718 30.165 8.334 8.334 5.707 14.041 12.682 17.392 21.74 3.714 9.33 5.345 27.81 5.345 54.532v147.019h46.832v-147.019c0-33.426-3.352-57.884-10.417-75.004-7.519-16.668-18.208-30.346-32.882-40.129z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "url(#c)",
    y: 506.252,
    x: 687.512,
    transform: "translate(2.056 70.185) scale(.9058)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M849.761 907.599h-6.703v270.758h45.836V907.599h-6.341z"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 998.612,
    fill: "url(#d)",
    y: 506.252,
    transform: "translate(2.056 70.185) scale(.9058)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M1131.571 907.599h-6.703v270.758h45.835V907.599H1164zm592.063 51.543c-7.337-17.755-19.385-32.158-35.147-42.484s-33.788-15.762-54.26-15.762c-19.748 0-38.136 4.71-54.895 14.041-12.048 6.703-23.099 15.399-33.426 26.813V907.6h-46.198v270.486h46.198v-100.821c0-33.154 1.631-56.253 4.348-68.301 4.71-18.117 14.403-33.426 28.806-45.474 14.403-12.41 30.437-18.389 48.825-18.389 15.762 0 28.444 3.986 37.865 11.414 9.33 7.7 16.034 19.113 19.385 34.513 2.355 9.33 3.352 28.806 3.352 57.884v129.174h46.198v-138.957c0-36.143-3.714-62.232-11.051-79.987z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M1337.38 901.168c-41.126 0-75.638 15.399-102.452 45.474-24.458 27.447-36.778 59.877-36.778 97.017 0 37.502 13.044 70.656 38.861 98.738s59.605 42.484 100.368 42.484c40.491 0 74.28-14.403 100.096-42.484s38.861-61.235 38.861-98.738c0-37.14-12.41-69.932-36.778-97.379-26.813-29.984-61.326-45.111-102.18-45.111zm46.561 226.644c-14.041 8.062-29.802 12.048-46.561 12.048s-32.429-3.986-46.561-12.41c-14.041-8.062-25.454-19.748-33.426-34.785-8.334-15.037-12.41-31.433-12.41-48.554 0-27.085 9.058-49.912 27.447-68.935 18.389-19.113 39.857-28.444 65.221-28.444 25.454 0 46.832 9.33 65.221 28.444s27.447 41.85 27.447 68.935c0 17.392-4.348 33.788-12.41 48.554-8.515 15.399-19.929 27.085-33.969 35.147z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M927.755 793.734h51.543v384.533h-51.543zm95.023 0h51.543v384.533h-51.543z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.704 691.735c-14.041 0-27.447 2.989-39.495 9.058-3.352 1.631-7.066 3.714-10.417 6.069V635.21H85.314v242.949h44.84v-11.414c2.989 1.993 6.069 3.986 9.058 5.707 12.048 6.341 25.454 9.693 40.129 9.693 25.454 0 47.557-9.33 65.221-27.81 18.117-18.389 27.085-40.854 27.085-66.942 0-26.451-9.058-48.825-26.813-67.576-17.936-18.751-39.676-28.081-65.131-28.081zm40.129 68.935c4.71 8.334 6.703 16.758 6.703 25.817s-2.355 17.392-6.703 25.817c-4.348 8.062-10.417 14.041-17.755 18.751-7.337 4.348-15.399 6.703-24.458 6.703-14.041 0-25.454-4.71-34.785-14.765-9.693-9.693-14.041-22.103-14.041-36.778 0-9.693 1.993-18.389 6.341-26.088 3.986-7.7 10.055-13.407 18.117-18.117s16.034-6.703 25.092-6.703c8.696 0 16.396 2.355 24.096 6.703 7.066 4.257 12.772 10.598 17.392 18.661zm203.816-53.898c-2.989-1.993-6.069-3.986-9.058-5.707-12.048-6.341-25.817-9.693-40.491-9.693-25.454 0-47.557 9.33-65.584 27.81-18.117 18.389-27.085 40.854-27.085 66.942 0 26.451 9.058 49.188 26.813 67.576 18.117 18.389 39.857 28.081 65.221 28.081 14.403 0 27.447-2.989 39.857-9.058 3.714-1.631 7.066-3.714 10.417-6.069v11.051h44.477V695.631H423.74v11.142zm-89.951 105.713c-4.71-8.334-6.703-16.758-6.703-25.454 0-9.058 2.355-17.392 6.703-25.454s10.417-14.041 17.755-18.751c7.7-4.348 15.762-6.703 24.458-6.703 14.041 0 25.454 4.71 34.785 14.403 9.693 9.693 14.041 21.74 14.041 36.778 0 9.693-1.993 18.389-6.341 26.088-3.986 7.7-10.055 13.407-17.755 17.755-8.062 4.71-16.034 6.703-25.092 6.703-8.696 0-16.758-2.355-24.096-6.703-7.428-4.257-13.407-10.236-17.755-18.661zm283.078-109.789c-11.051-7.337-23.733-11.051-37.865-11.051-13.407 0-26.088 3.352-37.502 9.33-2.718 1.631-5.707 3.352-8.334 5.345v-10.689h-44.84v182.076h44.84v-70.294c0-24.458 1.359-35.147 2.355-39.495 2.355-9.33 7.337-17.03 14.765-23.462 7.337-6.341 15.399-9.33 24.458-9.33 7.7 0 13.678 1.631 18.117 4.982 4.348 3.352 7.337 8.696 9.058 16.758.634 2.718 1.993 11.051 1.993 33.154v87.324h44.84v-93.303c0-23.462-2.355-40.491-7.337-52.177-5.435-12.048-13.769-22.103-24.549-29.168zm116.855 80.711 99.734-87.686H766.06l-54.895 48.191V635.12h-44.84v242.677h44.84V822.54l61.235 55.257h64.949z",
    fill: "#f68b1f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#939598",
    d: "m361.417 1047.825-2.355-15.762h-.634c-8.696 11.051-23.733 19.113-42.213 19.113-28.806 0-44.84-20.744-44.84-42.484 0-36.143 32.158-54.26 84.697-53.898v-2.355c0-9.33-3.714-24.73-29.078-24.73-14.041 0-28.806 4.348-38.499 10.689l-7.066-23.462c10.689-6.341 29.078-12.682 51.543-12.682 45.836 0 58.88 29.078 58.88 60.239v51.543c0 13.044.634 25.454 1.993 34.513h-32.429v-.725zm-4.71-69.932c-25.454-.634-49.912 4.982-49.912 26.813 0 14.041 9.058 20.382 20.382 20.382 14.403 0 24.73-9.33 28.081-19.748.996-2.718 1.359-5.707 1.359-8.062l.091-19.385z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-374 969h3-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaVirginiaBankAMillion);
export default __webpack_public_path__ + "static/media/usa_virginia_bank_a_million.1f9b8ca62cbbe91df0254a250743e520.svg";
export { ForwardRef as ReactComponent };